import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@environments/environment';
import { AuthService } from '@services/auth/auth.service';
import { EditorService } from '@services/wiki/editor.service';
import { FileService } from '@services/wiki/file.service';
import { Role } from 'app/shared/models/enum/role.enum';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';

@Component({
  selector: 'app-editor-container',
  templateUrl: './editor-container.component.html',
  styleUrls: ['./editor-container.component.scss']
})
export class EditorContainerComponent extends SubscriptionBaseComponent implements OnInit {

  private  provider: string = null;
  private isBizzDev = false;

  editable = false;
  chosenFilePath = '\\';
  chosenFileName: string;
  language: string;
  tabIndex = 0;
  selectedLanguage = '';
  languages: string[];

  constructor(
    private fileService: FileService,
    private editorService: EditorService,
    private authService: AuthService,
    private route: ActivatedRoute) {
      super();
   }

  ngOnInit(): void {
    this.initPage();
  }

  changeTab(event): void {
    this.tabIndex = event.index;
  }

  private initPage(): void {
    this.selectedLanguage = this.authService.getDecodedToken().language;
    const role = this.authService.getDecodedToken().role;
    this.isBizzDev = role.includes(Role.Administration$SuperAdmin);
    this.route.paramMap.subscribe(params => {
      const editable = sessionStorage.getItem(environment.editable);
      if (editable === 'true' && this.isBizzDev) {
        this.editable = true;
      }
      if (params.get('path') && params.get('path') !== '') {
        this.chosenFilePath = decodeURIComponent(escape(atob(params.get('path'))));
      } else {
        this.subscription.add(this.fileService.getFirstPageSub().subscribe(url => {
          this.chosenFilePath = url;
        }));
      }
    });

    // this.fileService.getLanguages(this.provider).subscribe(lg => {
    //   this.languages = lg;
    // });

    this.subscription.add(this.editorService.getEditMode().subscribe(mode => {
      if (this.isBizzDev) {
        this.editable = mode;
        this.tabIndex = 0;
      }
    }));

    this.subscription.add(this.fileService.getProviderSub().subscribe(provider => {
      this.provider = provider;
      this.fileService.getLanguages(this.provider).subscribe(lg => {
        this.languages = lg;
      });
    }));
  }
}
